<template>
    <div class="ManageTimeSheet">
        <span @click="dialogVisible = true">Modal</span>
        <div style="display: flex; align-items: center; justify-content: space-between !important;">
            <div style="display: flex; align-items: center;">
                <el-checkbox v-model="select_all" style="margin-right: 15px;" @change="selectAllEmployees()">Select all</el-checkbox>
                <div v-if="isEmpSelected" class="status-highliter" style="background-color: #25b57e; margin: 0; padding: 10px 25px; font-size: 13px" @click="approveBulkRequest()">Approve Selected</div>
            </div>
            <el-input v-model="emp_searching" placeholder="Search by employee name and id" style="width: 350px"></el-input>
        </div>

        <table v-loading="is_timesheet_loading" class="timsheet-table mt-2">
            <thead>
                <tr>
                    <th style="width: 3%;">&nbsp;</th>
                    <th>Employee</th>
                    <th>&nbsp;</th>
                    <th>TIME IN-TIME OUT</th>
                    <th>BREAK <span style="font-size: 0.6rem;">(HH:mm)</span></th>
                    <th>DURATION <span style="font-size: 0.6rem;">(HH:mm)</span></th>
                    <th>COST <span style="font-size: 0.6rem;">(INR)</span></th>
                    <th>DISTANCE</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>

            <div style="width: 100%; max-height: 400px; overflow-y: auto;">
                <tbody v-for="(time_sheet, time_sheet_index) in time_sheet_list" :key="time_sheet_index">
                    <tr style="border: none;">
                        <td style="width: 3%; height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                    </tr>

                    <tr style="background-color: #f2f2f2;">
                        <td style="width: 3%; height: 30px;">&nbsp;</td>
                        <td class="font-bold" style="height: 30px;">{{ moment(time_sheet.date).format('dddd, DD MMM YYYY') }}</td>
                        <td style="height: 30px;">&nbsp;</td>
                        <td style="height: 30px;">&nbsp;</td>
                        <td style="height: 30px;">&nbsp;</td>
                        <td style="height: 30px;">&nbsp;</td>
                        <td style="height: 30px;">&nbsp;</td>
                        <td style="height: 30px;">&nbsp;</td>
                        <td style="height: 30px;">&nbsp;</td>
                    </tr>

                    <tr v-for="(emp, emp_index) in time_sheet.emp_list" :key="emp_index" class="relative" :style="[emp.is_toggled ? { height: '200px', background: '#fafaff' } : '']">
                        <td style="width: 3%;">
                            <el-checkbox v-if="!emp.is_approved" v-model="emp.checked"></el-checkbox>
                        </td>
                        <td>
                            <div class="title ellipsis">{{ emp.employee_full_name }}</div>

                            <div class="mt-2 task-highliter" :style="[ emp.employee_department == 'Management' ? { backgroundColor: '#cd5cff' } : emp.employee_department == 'Team Members' ? { backgroundColor: '#099989' } : { backgroundColor: '#999' } ]" style="margin-top: 5px;">
                                {{ emp.employee_department }}
                            </div>
                            <!-- <div class="mt-2 sub-title">{{ emp.designation }}</div> -->
                        </td>
                        <td>
                            <div class="title">Actual</div>
                            <div class="mt-8">Scheduled</div>
                        </td>
                        <td>
                            <!-- <div v-if="!emp.cur_activity"> -->
                            <div>
                                <div class="title" v-if="emp.shift_start_datetime">
                                    {{ emp.shift_start_datetime | timeFilter }} 
                                        <span v-if="emp.shift_start_datetime && emp.shift_end_datetime">-</span> 
                                    {{ emp.shift_end_datetime | timeFilter }}
                                </div>

                                <div class="title" v-if="!emp.shift_start_datetime">
                                    -
                                </div>
                                
                                <el-popover
                                    placement="top"
                                    width="300"
                                    trigger="hover">
                                    <table class="scheduled-shift-table">
                                        <thead>
                                            <tr v-if="emp.schedule_start_time && emp.schedule_end_time">
                                                <th>Scheduled Time</th>
                                                <th>{{ emp.schedule_start_time | timeFilter }} - {{ emp.schedule_end_time | timeFilter }}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="emp.scheduled_breaks.length">
                                            <tr v-for="(brk, brk_index) in emp.scheduled_breaks" :key="brk_index">
                                                <td class="font-bold">Break {{ brk_index + 1 }}</td>
                                                <td>{{ brk.start_time | timeFilter }} - {{ brk.end_time | timeFilter }}</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="2" style="text-align: center; font-size: 10px; font-weight: 600; color: #e29d5a; padding: 5px;">
                                                    No data available
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="mt-8" v-if="emp.schedule_start_time && emp.schedule_end_time" slot="reference">
                                        {{ emp.schedule_start_time | timeFilter }} - {{ emp.schedule_end_time | timeFilter }}
                                    </div>

                                </el-popover>
                            </div>
                            
                            <!-- if weekly off or leave then displayed -->
                            <div v-if="emp.weekoff" class="mt-8">
                                Weekly Off
                            </div>

                            <div v-if="emp.leave" class="mt-8">
                                Leave
                            </div>

                            <div v-if="emp.no_shift" class="mt-8">
                                No shift
                            </div>
                        </td>

                        <td>
                            <el-popover
                                placement="bottom"
                                width="300"
                                trigger="hover">
                                <table class="scheduled-shift-table">
                                    <thead>
                                        <tr v-if="emp.break_duration">
                                            <th>Break Duration</th>
                                            <th>{{ emp.break_duration }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="emp.break1_start_datetime">
                                            <td class="font-bold">Break 1</td>
                                            <td>
                                                {{ emp.break1_start_datetime | timeFilter }} <span v-if="emp.break1_start_datetime && emp.break1_end_datetime">-</span> {{ emp.break1_end_datetime | timeFilter }}
                                            </td>
                                        </tr>
                                        <tr v-if="emp.break2_start_datetime">
                                            <td class="font-bold">Break 2</td>
                                            <td>
                                                {{ emp.break2_start_datetime | timeFilter }} <span v-if="emp.break2_start_datetime && emp.break2_end_datetime">-</span> {{ emp.break2_end_datetime | timeFilter }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="emp.break_duration" slot="reference" class="title">
                                    {{ emp.break_duration + ' Hrs' }}
                                </div>
                            </el-popover>
                            
                            <div v-if="!emp.break_duration">
                                -
                            </div>

                            <div style="color: #ef5753;" class="mt-1">(00:12 Hrs)</div>

                            <div class="mt-4">(00:12 Hrs)</div>

                        </td>

                        <td>
                            <div class="title">
                                {{ emp.shift_duration ? emp.shift_duration + ' Hrs' : '-' }}
                            </div>


                            <div class="mt-1" style="color: #ef5753;">(01:30 Hrs)</div>

                            <div class="mt-4">12:30 Hrs</div>
                        </td>
                        
                        <td>
                            <div class="title">{{ emp.actual_total_cost }}</div>

                            <div class="mt-8" style="color: #ef5753;">(INR 150)</div>
                        </td>
                        
                        <td>
                            <div>
                                <el-popover
                                    placement="bottom"
                                    width="300"
                                    trigger="hover">

                                    <div slot="reference">
                                        <span class="title">In</span>&nbsp;&nbsp;
                                        <span>
                                            {{ emp.shift_start_distance > 900 ? (emp.shift_start_distance / 1000).toFixed(2) + ' Km' : emp.shift_start_distance ? emp.shift_start_distance + ' M' : '-' }}
                                        </span>
                                        <span v-if="emp.shift_start_distance">away</span>
                                    </div>
                                </el-popover>
                            </div>

                            <el-popover
                                placement="bottom"
                                width="300"
                                trigger="hover">

                                <div slot="reference">
                                    <div class="mt-8">
                                        <span class="title">Out</span>&nbsp;&nbsp;
                                        <span>
                                            {{ emp.shift_end_distance > 900 ? (emp.shift_end_distance / 1000).toFixed(2) + ' Km' : emp.shift_end_distance ? emp.shift_end_distance + ' M' : '-' }}
                                        </span>
                                        <span v-if="emp.shift_end_distance">away</span>
                                    </div>
                                </div>
                            </el-popover>
                        </td>

                        <td>
                            <div class="flex items-center">
                                
                                <div v-if="moment(time_sheet.date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD') && !emp.shift_start_datetime" class="status-highliter" style="background-color: #ddd; color: #fff; cursor: not-allowed;">{{ emp.is_approved ? 'Approved' : 'Pending' }}</div>

                                <div class="status-highliter" v-else :style="[ emp.is_approved ? {backgroundColor: '#25b57e'} : {backgroundColor: '#ff5353'} ]" @click="approveTimeSheetRequest(emp, time_sheet_index, emp_index)">{{ emp.is_approved ? 'Approved' : 'Pending' }}</div>
                                <div>
                                    <i class="el-icon-edit-outline cursor-pointer mr-2 default-icon text-amplitude text-lg"></i>
                                    <i class="el-icon-delete cursor-pointer default-icon text-amplitude text-lg mr-3" @click="deleteTimesheet(emp)"></i>
                                </div>
                                <!-- <span @click="toggleEditView(time_sheet_index, emp_index)">
                                    <i v-if="!emp.is_toggled" class="el-icon-arrow-down" style="font-size: 1rem; color: #c6c6c6; font-weight: bold; cursor: pointer;"></i>
                                    <i v-if="emp.is_toggled" class="el-icon-arrow-up" style="font-size: 1rem; color: #c6c6c6; font-weight: bold; cursor: pointer;"></i>
                                </span> -->

                                <!-- <el-popover
                                    placement="left"
                                    width="50"
                                    trigger="click">

                                    <div>
                                        <div class="option-menu" @click="toggleEditView(time_sheet_index, emp_index)">Edit</div>
                                        <div class="option-menu" @click="deleteTimesheet(emp)">Delete</div>
                                    </div>
                                    <img slot="reference" src="../../../assets/images/menu.png" class="ml-1 cursor-pointer" style="width: 22px; cursor: pointer;">
                                </el-popover> -->
                                <!-- <span class="ml-1 cursor-pointer">
                                    <img src="../../../assets/images/edit.png" width="20" alt="" @click="toggleEditView(time_sheet_index, emp_index)" />
                                </span> -->
                            </div>
                        </td>

                        <!-- table to edit employee shift -->
                        <!-- <table v-if="emp.is_toggled" style="width: 100%; padding: 10px 0; position: absolute; bottom: 0;">
                            <tbody>
                                <tr style="border: none;">
                                   
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">START TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :picker-options="{
                                                format: ('HH:mm')
                                            }"
                                            placeholder="Start Time"
                                            @change="emp.edit_timesheet_end_hours = ''; emp.edit_timesheet_break1_start_hours = ''; emp.edit_timesheet_break1_end_hours = ''; emp.edit_timesheet_break2_start_hours = ''; emp.edit_timesheet_break2_end_hours = ''">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">END TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="Start Time"
                                            :picker-options="timesheetEndTimePickerOptions(emp)"
                                            :disabled="!emp.edit_timesheet_start_hours">
                                        </el-time-picker>
                                    </td>
                                    
                                </tr>

                                <tr style="border: none;">
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 1 START TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break1_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :picker-options="timesheetBreak1StartTimePickerOption(emp)"
                                            placeholder="Start Time">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 1 END TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break1_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="End Time"
                                            :disabled="!emp.edit_timesheet_break1_start_hours"
                                            :picker-options="timesheetBreak1EndTimePickerOption(emp)"
                                            @change="emp.edit_timesheet_break2_start_hours = ''; emp.edit_timesheet_break2_end_hours = ''">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 2 START TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break2_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="Start Time"
                                            :disabled="emp.edit_timesheet_break1_start_hours !='' && emp.edit_timesheet_break1_end_hours == ''"
                                            :picker-options="timesheetBreak2StartTimePickerOption(emp)">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 2 END TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break2_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :disabled="emp.edit_timesheet_break1_start_hours !='' && emp.edit_timesheet_break1_end_hours == '' || emp.edit_timesheet_break2_start_hours == ''"
                                            :picker-options="timesheetBreak2EndTimePickerOption(emp)"
                                            placeholder="Start Time">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">&nbsp;</label>
                                        <el-button v-if="!emp.weekoff && !emp.leave" size="mini" type="success" class="action-btn" @click="updateTimesheet(emp)">SAVE</el-button>
 
                                        <el-button v-if="emp.weekoff || emp.leave" size="mini" type="success" class="action-btn" @click="openConfirmation(emp, emp.weekoff ? 'REMOVE_WEEKLY_OFF' : emp.leave ? 'REMOVE_LEAVE' : '', time_sheet_index)">SAVE</el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table> -->
                    </tr>
                </tbody>

                <!-- for no shift employees -->
                <tbody v-if="emp_with_no_shift_list.length">
                    <tr style="border: none;">
                        <td style="width: 3%; height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                        <td style="height: 10px;">&nbsp;</td>
                    </tr>
                    <tr style="background-color: #f2f2f2;">
                        <td style="width: 3%; height: 35px;">&nbsp;</td>
                        <td class="font-bold" style="height: 35px;">No shift</td>
                        <td style="height: 35px;">&nbsp;</td>
                        <td style="height: 35px;">&nbsp;</td>
                        <td style="height: 35px;">&nbsp;</td>
                        <td style="height: 35px;">&nbsp;</td>
                        <td style="height: 35px;">&nbsp;</td>
                        <td style="height: 35px;">&nbsp;</td>
                        <td style="height: 35px;">&nbsp;</td>
                    </tr>

                    <tr class="relative" v-for="(no_shift, shift_index) in emp_with_no_shift_list" :key="shift_index+new Date().getTime()" :style="[no_shift.is_toggled ? { height: '200px', background: '#fafaff' } : '']">
                        <td style="width: 3%;">
                            <el-checkbox v-if="!no_shift.is_approved" v-model="no_shift.checked"></el-checkbox>
                        </td>
                        <td>
                            <div class="title ellipsis">{{ no_shift.employee_full_name }}</div>

                            <div class="mt-2 task-highliter" :style="[ no_shift.employee_department == 'Management' ? { backgroundColor: '#cd5cff' } : no_shift.employee_department == 'Team Members' ? { backgroundColor: '#099989' } : { backgroundColor: '#999' } ]" style="margin-top: 5px;">{{ no_shift.employee_department }}</div>
                            <!-- <div class="mt-2 sub-title">{{ no_shift.designation }}</div> -->
                        </td>
                        
                        <td>
                            <div class="title">Actual</div>
                            <div class="mt-8">Scheduled</div>
                        </td>

                        <td>
                            <!-- if weekly off or leave then displayed -->
                            <div v-if="no_shift.cur_activity" class="" style="margin-top: 5px;">
                                {{ no_shift.cur_activity }}
                            </div>
                        </td>
                        
                        <td>
                            -
                        </td>

                        <td class="title">
                            {{ no_shift.shift_duration ? no_shift.shift_duration + ' Hrs' : '-' }}
                        </td>
                        
                        <td>
                            {{ no_shift.overtime_duration ? no_shift.overtime_duration + ' Hrs' : '-' }}
                        </td>
                        
                        <td>
                            <div>
                                <span class="title">In</span>&nbsp;&nbsp;
                                <span>
                                    {{ no_shift.shift_start_distance > 900 ? (no_shift.shift_start_distance / 1000).toFixed(2) + ' Km' : no_shift.shift_start_distance ? no_shift.shift_start_distance + ' M' : '-' }}
                                </span>
                                <span v-if="no_shift.shift_start_distance">away</span>
                            </div>

                            <div class="mt-2">
                                <span class="title">Out</span>&nbsp;&nbsp;
                                <span>
                                    {{ no_shift.shift_end_distance > 900 ? (no_shift.shift_end_distance / 1000).toFixed(2) + ' Km' : no_shift.shift_end_distance ? no_shift.shift_end_distance + ' M' : '-' }}
                                </span>
                                <span v-if="no_shift.shift_end_distance">away</span>
                            </div>
                        </td>

                        <td>
                            <div class="flex items-center">
                                <div class="status-highliter" :style="[ no_shift.is_approved ? {backgroundColor: '#25b57e'} : {backgroundColor: '#ff5353'} ]" @click="approveTimeSheetRequest(no_shift, shift_index)">{{ no_shift.is_approved ? 'Approved' : 'Pending' }}</div>

                                <span @click="toggleEditViewForNoShifts(shift_index)">
                                    <i v-if="!no_shift.is_toggled" class="el-icon-arrow-down" style="font-size: 1rem; color: #c6c6c6; font-weight: bold; cursor: pointer;"></i>
                                    <i v-if="no_shift.is_toggled" class="el-icon-arrow-up" style="font-size: 1rem; color: #c6c6c6; font-weight: bold; cursor: pointer;"></i>
                                </span>

                                <el-popover
                                    placement="left"
                                    width="50"
                                    trigger="click">

                                    <div>
                                        <div class="option-menu" @click="toggleEditViewForNoShifts(shift_index)">Edit</div>
                                        <div class="option-menu" @click="deleteTimesheet(no_shift)">Delete</div>
                                    </div>
                                    <img slot="reference" src="../../../assets/images/menu.png" class="ml-1 cursor-pointer" style="width: 22px; cursor: pointer;">
                                </el-popover>
                            </div>
                        </td>

                        <!-- table to edit employee shift -->
                        <table v-if="no_shift.is_toggled" style="width: 100%; padding: 10px 0; position: absolute; bottom: 0;">
                            <tbody>
                                <tr style="border: none;">
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;" colspan="2">
                                        <label class="text-left">FULL NAME</label>
                                        <el-input v-model="no_shift.employee_full_name" size="mini" :disabled="true"></el-input>
                                    </td>

                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">START TIME</label>
                                        <el-time-picker
                                            v-model="no_shift.edit_timesheet_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :picker-options="{
                                                format: ('HH:mm')
                                            }"
                                            placeholder="Start Time"
                                            @change="no_shift.edit_timesheet_end_hours = ''; no_shift.edit_timesheet_break1_start_hours = ''; no_shift.edit_timesheet_break1_end_hours = ''; no_shift.edit_timesheet_break2_start_hours = ''; no_shift.edit_timesheet_break2_end_hours = ''">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">END TIME</label>
                                        <el-time-picker
                                            v-model="no_shift.edit_timesheet_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="Start Time"
                                            :picker-options="timesheetEndTimePickerOptions(no_shift)"
                                            :disabled="!no_shift.edit_timesheet_start_hours">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">FUNCTION</label>
                                        <el-select
                                            v-model="no_shift.edit_timesheet_function"
                                            size="mini"
                                            collapse-tags
                                            style="width: 100%;"
                                            placeholder="Select">
                                            <el-option
                                                v-for="item in function_list"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </td>
                                </tr>

                                <tr style="border: none;">
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 1 START TIME</label>
                                        <el-time-picker
                                            v-model="no_shift.edit_timesheet_break1_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :picker-options="timesheetBreak1StartTimePickerOption(no_shift)"
                                            placeholder="Start Time">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 1 END TIME</label>
                                        <el-time-picker
                                            v-model="no_shift.edit_timesheet_break1_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="End Time"
                                            :disabled="!no_shift.edit_timesheet_break1_start_hours"
                                            :picker-options="timesheetBreak1EndTimePickerOption(no_shift)"
                                            @change="no_shift.edit_timesheet_break2_start_hours = ''; no_shift.edit_timesheet_break2_end_hours = ''">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 2 START TIME</label>
                                        <el-time-picker
                                            v-model="no_shift.edit_timesheet_break2_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="Start Time"
                                            :disabled="no_shift.edit_timesheet_break1_start_hours !='' && no_shift.edit_timesheet_break1_end_hours == ''"
                                            :picker-options="timesheetBreak2StartTimePickerOption(no_shift)">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 2 END TIME</label>
                                        <el-time-picker
                                            v-model="no_shift.edit_timesheet_break2_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :disabled="no_shift.edit_timesheet_break1_start_hours !='' && no_shift.edit_timesheet_break1_end_hours == '' || no_shift.edit_timesheet_break2_start_hours == ''"
                                            :picker-options="timesheetBreak2EndTimePickerOption(no_shift)"
                                            placeholder="Start Time">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">&nbsp;</label>
                                        <el-button v-if="!no_shift.weekly_off_id && !no_shift.leave_id" size="mini" type="success" class="action-btn" @click="assignShiftToNoShiftAssignedEmp(no_shift)">SAVE</el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </tr>
                </tbody>
            </div>
        </table>

        <div v-if="!time_sheet_list.length" style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
          No data available
        </div>


        <!-- Edit dialog -->
        <el-dialog
            title="Update Timesheet"
            :visible.sync="dialogVisible"
            width="50%"
            custom-class="ns-dialog"
            :before-close="handleClose">
            <div class="ts-mng-modal">
                <div class="text-sm font-semibold mt-4 ns-avatar-sec">
                    <img class="ns-img-avatar mr-3" :src="generateAvatar('Ajay Patil')" alt="Avatar">
                    <div>
                        <span>Ajay Patil</span>
                        <p class="mt-2 text-xs" style="color: #a1a1a1">Store Manager</p>
                        <!-- <p class="text-xs font-normal">Emp Id - 3250</p> -->
                    </div>
                </div>
                <!-- Ajay Patil (Mon, 21st Jan, 21) -->
                <!-- Schedule -->
                <p class="text-sm font-semibold text-black mt-8">Scheduled Information</p>
                <div class="border rounded mt-3 p-5 text-center">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Location </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">Lake City Mall</span>
                                </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Date </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">Lake City Mall</span>
                                </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Time </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">Lake City Mall</span>
                                </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Breaks </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">Lake City Mall</span>
                                </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Break Duration </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">Lake City Mall</span>
                                </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="4" :xl="4" class="my-2">
                            <span class="font-semibold"> Total Duration </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">Lake City Mall</span>
                                </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- Timesheet -->
                <p class="text-sm font-semibold text-black mt-8">Timesheet</p>
                <div class="border rounded mt-3 p-5">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                            <span class="font-semibold"> Status </span>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="my-2">
                            <el-select v-model="value" style="width:100%" placeholder="Select">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-3">
                            <span class="font-semibold"> Actual Time </span>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                            <p class="text-sm font-semibold mb-1" style="font-size:12px">In Time</p>
                            <el-select v-model="value" style="width:100%" placeholder="Select">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                            <p class="text-sm font-semibold mb-1" style="font-size:12px">Out Time</p>
                            <el-select v-model="value" style="width:100%" placeholder="Select">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="my-3 ml-5">
                            <span class="font-semibold"> Shift Duration </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">09:06 Hrs</span>
                                </div>
                        </el-col>
                    </el-row>
                    <!-- Breaks -->
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-3">
                            <span class="font-semibold"> Break 1 </span>
                        </el-col>
                       <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                            <p class="text-sm font-semibold mb-1" style="font-size:12px">Start Time</p>
                            <el-select v-model="value" style="width:100%" placeholder="Select">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                       <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                            <p class="text-sm font-semibold mb-1" style="font-size:12px">End Time</p>
                            <el-select v-model="value" style="width:100%" placeholder="Select">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3" class="my-3 ml-5">
                            <span class="font-semibold"> Break Duration </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">09:06 Hrs</span>
                                </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-3">
                            <span class="font-semibold"> Break 2 </span>
                        </el-col>
                       <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                            <p class="text-sm font-semibold mb-1" style="font-size:12px">Start Time</p>
                            <el-select v-model="value" style="width:100%" placeholder="Select">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                       <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="my-3">
                            <p class="text-sm font-semibold mb-1" style="font-size:12px">End Time</p>
                            <el-select v-model="value" style="width:100%" placeholder="Select">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3" class="my-3 ml-5">
                            <span class="font-semibold"> Break Duration </span>
                                <div class="mt-3">
                                    <span class="text-sm font-normal" style="font-size:12px">09:06 Hrs</span>
                                </div>
                        </el-col>
                    </el-row>
                    
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="ns-cancel-btn" @click="dialogVisible = false">Cancel</el-button>
                <el-button class="ns-approve-btn" @click="dialogVisible = false">Approve</el-button>
            </span>
        </el-dialog>
        <!-- Edit dialog -->
    </div>
</template>

<script>
import LabourPalnningService from "../../../services/labourPalnningService";
import axios from "axios";
import moment from 'moment';
import { EventBus } from "../../../eventBus";

export default {
    name: 'ManageTimeSheet',
    filters:{
        utcToLocaltimeFilter(time){
            if(time){
                var currentTime = new Date(time + ' UTC').toString();
                return moment(currentTime).format('HH:mm');
            }
        },
        utcToLocalDateFilter(time){
            if(time){
                var currentTime = new Date(time + ' UTC').toString();
                return moment(currentTime).format();
            }
        },
        timeFilter(time){
            if(time){
                return moment(time).format('HH:mm');
            }
        },
    },

    props: {
        selectedStore: {
            type: String,
            default: () => ''
        },
        startDate: {
            type: String,
            default: () => ''
        },
        endDate: {
            type: String,
            default: () => ''
        },
        searchedEmployee:{
            type: String,
            default: () => ''
        }
    },

    data() {
        return {
            select_all: false,
            moment: moment,
            time_sheet_list: [],
            emp_with_no_shift_list: [],
            is_timesheet_loading: false,
            dialogVisible: false,
            function_list: [
                {
                    label: 'Veg',
                    value: 'veg'
                },
                {
                    label: 'Non Veg',
                    value: 'non veg'
                },
                {
                    label: 'POS',
                    value: 'pos'
                },
                {
                    label: 'Shift Manager',
                    value: 'shift manager'
                }
            ],
            emp_searching: ''
        }
    },

    computed: {
        isEmpSelected(){
            return this.getSelected();
        },

        // filterTimeSheet: function() {
        //     if (!this.searchedEmployee.trim().length) {
        //         return this.time_sheet_list;
        //     } else {
        //         return this.time_sheet_list.forEach(element => {
        //             element.emp_list.filter(item => {
        //             console.log(item, item.employee_full_name);
        //                 var words = _.words(item.employee_full_name)
        //                     .join(" ")
        //                     .toLowerCase();
        //                     words = item.employee_full_name.toLowerCase();
        //                 var isSubstring = words.indexOf(this.searchedEmployee.toLowerCase()) !== -1;
        //                 return isSubstring;
        //             });
        //         });
        //     }
        // },
    },

    // watch: {
    //     selectedStore(newValue, oldValue){
    //         if(newValue){
    //             this.getTodaysTimesheetDetails();
    //         }
    //     },

    //     startDate(newValue, oldValue){
    //         if(newValue){
    //             this.getTodaysTimesheetDetails();
    //         }
    //     },

    //     endDate(newValue, oldValue){
    //         if(newValue){
    //             this.getTodaysTimesheetDetails();
    //         }
    //     }
    // },

    mounted() {
        EventBus.$on("loadAllApis", () => {
            this.getTodaysTimesheetDetails();
		});
    },

    methods: {
        generateAvatar(empName) {
            empName = empName.split(' ');
            const firstLetter = empName[0].charAt(0) + empName[1].charAt(0);
            let randomColor;
            do {
            randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
            } while (randomColor === "#ffffff");
            const canvas = document.createElement("canvas");
            canvas.width = 100;
            canvas.height = 100;
            const context = canvas.getContext("2d");
            context.font = "50px Arial";
            context.textAlign = "center";

            context.fillStyle = randomColor;
            context.fillRect(0, 0, canvas.width, canvas.height);

            context.fillStyle = "#FFFFFF";
            context.fillText(firstLetter, canvas.width / 2, canvas.height / 2 + context.measureText(firstLetter).actualBoundingBoxAscent / 2);

            const dataURL = canvas.toDataURL();

            const img = document.createElement("img");
            return dataURL;

        },
        timesheetEndTimePickerOptions(emp_obj){
            let end_time = '23:59:00';
            let obj = { selectableRange: `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - ${end_time}`, format: 'HH:mm' };

            return obj;
        },

        timesheetBreak1StartTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        timesheetBreak1EndTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_break1_start_hours && emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_break1_start_hours && !emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_start_hours)} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        timesheetBreak2StartTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break1_start_hours && emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_end_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours && !emp_obj.edit_timesheet_break1_start_hours && !emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - 23:59:00`;
            }else if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours && !emp_obj.edit_timesheet_break1_start_hours && !emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break1_start_hours && emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_end_hours)} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        timesheetBreak2EndTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break2_start_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break2_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break2_start_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break2_start_hours).format('HH:mm:ss')} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        toggleEditView(timslot_index, emp_index){
            this.time_sheet_list[timslot_index].emp_list[emp_index].is_toggled = !this.time_sheet_list[timslot_index].emp_list[emp_index].is_toggled;

            // if current is active then close remaining all
            for(let i=0; i<this.time_sheet_list.length; i++){
                for(let j=0; j<this.time_sheet_list[i].emp_list.length; j++){
                    if(this.time_sheet_list[i].emp_list[j].employee != this.time_sheet_list[timslot_index].emp_list[emp_index].employee){
                        this.time_sheet_list[i].emp_list[j].is_toggled = false;
                    }
                }
            }

            // closed no shift opened edit view
            for(let i=0; i<this.emp_with_no_shift_list.length; i++){
                this.emp_with_no_shift_list[i].is_toggled = false;
            }
        },

        toggleEditViewForNoShifts(index){
            // console.log(this.emp_with_no_shift_list[index])
            this.emp_with_no_shift_list[index].is_toggled = !this.emp_with_no_shift_list[index].is_toggled;

            // closed remaining all
            for(let i=0; i<this.time_sheet_list.length; i++){
                for(let j=0; j<this.time_sheet_list[i].emp_list.length; j++){
                    this.time_sheet_list[i].emp_list[j].is_toggled = false;
                }
            }
        },

        // api to accepet timesheet request
        approveTimeSheetRequest(emp, timesheet_index, emp_index){
            // console.log(emp)
            this.is_timesheet_loading = true;     //enabled loader

            this.time_sheet_list[timesheet_index].emp_list[emp_index].is_approved = !this.time_sheet_list[timesheet_index].emp_list[emp_index].is_approved;

            let params = {
                id: emp.timesheet_id,
                approved: this.time_sheet_list[timesheet_index].emp_list[emp_index].is_approved
            };

            LabourPalnningService.changeTimeSheetStatusNetworkCallBack(params)
            .then(response => {
				if (response.status == 200) {
                    this.getTodaysTimesheetDetails();   //called api to get updated status
				} else {
                    this.is_timesheet_loading = false;     //disabled loader

                    this.time_sheet_list[timesheet_index].emp_list[emp_index].is_approved = !this.time_sheet_list[timesheet_index].emp_list[emp_index].is_approved;     //if api failed then reset timesheet status
				}
            })
            .catch(e =>{
                console.log('error', e);

                this.is_timesheet_loading = false;     //disabled loader

                this.time_sheet_list[timesheet_index].emp_list[emp_index].is_approved = !this.time_sheet_list[timesheet_index].emp_list[emp_index].is_approved;     //if api failed then reset timesheet status
            })
        },

        getTodaysTimesheetDetails() {
            if(this.selectedStore){
                this.is_timesheet_loading = true;     //enabled loader

                let timesheet_params = {
                    start_date: moment(this.startDate).format('YYYY-MM-DD'),
                    end_date: moment(this.endDate).format('YYYY-MM-DD'),
                    filters: {
                        outlets: [this.selectedStore],
                        regions: [],
                        subregions: [],
                        countries: []
                    }
                };

                axios.all([this.completeTimesheetDetails(timesheet_params)])
                .then(axios.spread((timesheetRes) => {
                    // console.log("timesheetRes", timesheetRes);

                    if(timesheetRes.status == 200){
                        let time_sheet_list = JSON.parse(timesheetRes.data).timesheets;
                        let time_sheet_summary = JSON.parse(timesheetRes.data).summary;
                        // console.log("time_sheet_list", time_sheet_list);

                        let temp_time_sheet_list = [];
                        let temp_emp_with_no_shift_list = [];

                        this.time_sheet_list = [];
                        this.emp_with_no_shift_list = [];


                        let obj = {
                            scheduled_labour_hours: time_sheet_summary.scheduled_hours,
                            scheduled_labour_cost: Number(time_sheet_summary.scheduled_total_cost).toFixed(2),
                            actual_labour_hours: time_sheet_summary.actual_hours,
                            actual_labour_cost: (time_sheet_summary.actual_total_cost).toFixed(2),
                            total_leaves: time_sheet_summary.leave_count,
                            total_absents: time_sheet_summary.absent_count,
                            total_late: time_sheet_summary.late_by,
                            total_weekly_off: time_sheet_summary.weekoff_count,
                            total_overtime: Number(time_sheet_summary.overtime).toFixed(2),
                            total_early_out: time_sheet_summary.early_left_by,
                        }

                        // commit timesheet summary in vue store
                        this.$store.commit('commitTimesheetSummary', obj);

                        if(time_sheet_list.length){

                            let unique_timesheet_emps = _.uniqBy(time_sheet_list, 'shift_date');

                            const sortedActivities = unique_timesheet_emps.slice().sort((a, b) => new Date(b.shift_date) - new Date(a.shift_date));
                            
                            // console.log('sortedActivities', sortedActivities);

                            for(let i=0; i<sortedActivities.length; i++){
                                
                                let obj = {};
                                obj.date = sortedActivities[i].shift_date;
                                obj.emp_list = [];

                                // for employees who have assigned shift
                                let filtered_emp_by_shift_time = time_sheet_list.filter((el) =>{
                                    return el.shift_date == sortedActivities[i].shift_date;
                                });

                                if(filtered_emp_by_shift_time.length){
                                    for(let j=0; j<filtered_emp_by_shift_time.length; j++){
                                        let emp_obj = {
                                            employee_full_name: filtered_emp_by_shift_time[j].employee_full_name,
                                            employee: filtered_emp_by_shift_time[j].employee_id,
                                            user_id: filtered_emp_by_shift_time[j].user_id,
                                            outlet: filtered_emp_by_shift_time[j].store,
                                            shift_date: filtered_emp_by_shift_time[j].shift_date,
                                            function: '',
                                            employee_department: filtered_emp_by_shift_time[j].employee_department,
                                            
                                            shift_start_datetime: filtered_emp_by_shift_time[j].shift_start_datetime ? (this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].shift_start_datetime)) : '',
                                        
                                            shift_end_datetime: filtered_emp_by_shift_time[j].shift_end_datetime ? (this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].shift_end_datetime)) : '',

                                            schedule_start_time: filtered_emp_by_shift_time[j].scheduled_start_time ? moment(filtered_emp_by_shift_time[j].scheduled_start_time).format('YYYY-MM-DD HH:mm:ss') : '',
                                            
                                            schedule_end_time: filtered_emp_by_shift_time[j].scheduled_end_time ? moment(filtered_emp_by_shift_time[j].scheduled_end_time).format('YYYY-MM-DD HH:mm:ss') : '',
                                            
                                            break1_start_datetime: filtered_emp_by_shift_time[j].break1_start_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break1_start_datetime) : '',

                                            break1_end_datetime: filtered_emp_by_shift_time[j].break1_end_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break1_end_datetime) : '',

                                            break2_start_datetime: filtered_emp_by_shift_time[j].break2_start_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break2_start_datetime) : '',
                                            
                                            break2_end_datetime: filtered_emp_by_shift_time[j].break2_end_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break2_end_datetime) : '',
                                            
                                            break_duration: filtered_emp_by_shift_time[j].total_breaks,
                                            shift_duration: filtered_emp_by_shift_time[j].total_duration,
                                            overtime_duration: filtered_emp_by_shift_time[j].total_overtime,
                                            
                                            shift_start_distance: filtered_emp_by_shift_time[j].shift_start_distance,
                                            shift_end_distance: filtered_emp_by_shift_time[j].shift_end_distance,
                                            
                                            is_approved: filtered_emp_by_shift_time[j].is_approved,
                                            cur_activity: filtered_emp_by_shift_time[j].cur_activity,
                                            scheduled_breaks: [],
                                            // is_backdated_shift: false,

                                            weekoff: filtered_emp_by_shift_time[j].weekoff,
                                            leave: filtered_emp_by_shift_time[j].leave,
                                            no_shift: filtered_emp_by_shift_time[j].no_shift,
                                            timesheet_id: filtered_emp_by_shift_time[j].timesheet_id,
                                            
                                            is_toggled: false,
                                            checked: false,

                                            actual_total_cost: filtered_emp_by_shift_time[i].actual_total_cost,
                                            late_by: filtered_emp_by_shift_time[i].late_by,
                                            early_left_by: filtered_emp_by_shift_time[i].early_left_by,
    
                                            // filled details for edit inputs
                                            edit_timesheet_start_hours: filtered_emp_by_shift_time[j].shift_start_datetime ? (this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].shift_start_datetime)) : '',
                                            
                                            edit_timesheet_end_hours: filtered_emp_by_shift_time[j].shift_end_datetime ? (this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].shift_end_datetime)) : '',
                                            
                                            edit_timesheet_break1_start_hours: filtered_emp_by_shift_time[j].break1_start_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break1_start_datetime) : '',

                                            edit_timesheet_break1_end_hours: filtered_emp_by_shift_time[j].break1_end_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break1_end_datetime) : '',

                                            edit_timesheet_break2_start_hours: filtered_emp_by_shift_time[j].break2_start_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break2_start_datetime) : '',
                                            
                                            edit_timesheet_break2_end_hours: filtered_emp_by_shift_time[j].break2_end_datetime ? this.$options.filters.utcToLocalDateFilter(filtered_emp_by_shift_time[j].break2_end_datetime) : '',
                                            
                                            edit_timesheet_function: ''
                                        }

                                        obj.emp_list.push(emp_obj);
                                    }
                                }

                                temp_time_sheet_list.push(obj);
                            }

                            this.time_sheet_list = temp_time_sheet_list;
                        }

                    }
                }))
                .catch(err => {
                    console.log(err);
                    this.is_timesheet_loading = false;
                })
                .finally(() => {
                    this.is_timesheet_loading = false;
                });
            }
        },

        selectAllEmployees(){
            for(var i=0; i<this.time_sheet_list.length; i++){
                for(var j=0; j< this.time_sheet_list[i].emp_list.length; j++){
                    if(!this.time_sheet_list[i].emp_list[j].is_approved){
                        if(this.select_all){
                            this.time_sheet_list[i].emp_list[j].checked = true
                        }else{
                            this.time_sheet_list[i].emp_list[j].checked = false;
                        }
                    }
                }
            }
        },

        getSelected(){
            for(var i=0; i<this.time_sheet_list.length; i++){
                for(var j=0; j< this.time_sheet_list[i].emp_list.length; j++){
                    if(this.time_sheet_list[i].emp_list[j].checked){
                        return true;
                    }
                }
            }

            return false;
        },

        approveBulkRequest(){
            let timesheets = [];
            for(var i=0; i<this.time_sheet_list.length; i++){
                for(var j=0; j< this.time_sheet_list[i].emp_list.length; j++){
                    if(this.time_sheet_list[i].emp_list[j].checked){
                        let obj = {};
                        obj.id = this.time_sheet_list[i].emp_list[j].timesheet_id;
                        obj.approved = true;

                        timesheets.push(obj);
                    }
                }
            }

            if(timesheets.length){
                this.is_timesheet_loading = true;   //enabled loader
                LabourPalnningService.approveTimeSheetInBulkNetworkCallBack({timesheets})
                .then(response => {
                    if (response.status == 200) {
                        this.getTodaysTimesheetDetails();   //called get timesheet api to get updated shifts

                        this.select_all = false;
                    } else {
                        this.is_timesheet_loading = false;   //disabled loader
                    }
                })
                .catch((e) =>{
                    console.log('error', e);
                    this.is_timesheet_loading = false;   //disabled loader
                })
            }
        },

        updateTimesheet(emp_obj){
            if(emp_obj.edit_timesheet_start_hours || emp_obj.edit_timesheet_end_hours || emp_obj.edit_timesheet_break1_start_hours || emp_obj.edit_timesheet_break1_end_hours || emp_obj.edit_timesheet_break2_start_hours || emp_obj.edit_timesheet_break2_end_hours){

                let activities = [];
                // any activity of break 1 then activity_num is 1
                // any activity of break 2 then activity_num is 2
                // any activity of start shift or end shift then activity_num is 1

                // according to acitivies pushed activiy object to acitivies list

                // there are 6 activies to edit
                for(let i=0; i<6; i++){
                    let obj = {
                        employee: '',
                        outlet: '',
                        activity: '',
                        activity_num: '',
                        shift_date: '',
                        datetime: '',
                        distance: null,
                        location: null,
                        lat: null,
                        long: null,
                        note: null
                    };

                    if(i==0 && emp_obj.edit_timesheet_start_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'shift_start';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_start_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==1 && emp_obj.edit_timesheet_end_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'shift_end';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_end_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==2 && emp_obj.edit_timesheet_break1_start_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_start';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break1_start_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==3 && emp_obj.edit_timesheet_break1_end_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_end';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break1_end_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==4 && emp_obj.edit_timesheet_break2_start_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_start';
                        obj.activity_num = 2;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break2_start_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==5 && emp_obj.edit_timesheet_break2_end_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_end';
                        obj.activity_num = 2;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break2_end_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }
                }

                // console.log('activities', activities);

                this.is_timesheet_loading = true;   //enabled loader

                LabourPalnningService.updateTodaysTimesheetInBulkNetworkCallBack({activities : activities})
                    .then(response => {
                        if (response.status == 200) {
                            this.getTodaysTimesheetDetails();   //called get timesheet api to get updated shifts
                        }else{
                            activities = [];
                            this.is_timesheet_loading = false;   //disabled loader
                        }
                    })
                    .catch((e) =>{
                        console.log('error', e);
                        activities = [];
                        this.is_timesheet_loading = false;   //disabled loader
                    })
            }else{
                this.$notify.error({
                    title: "Errror",
                    message: 'Please select input first'
                });
            }
        },

        deleteTimesheet(emp_obj){
            this.is_timesheet_loading = true;   //enabled loader

            LabourPalnningService.deleteTimesheetInBulkNetworkCallBack({id : emp_obj.timesheet_id})
                .then(response => {
                    if (response.status == 204) {
                        this.getTodaysTimesheetDetails();   //called get timesheet api to get updated shifts
                    }else{
                        this.is_timesheet_loading = false;   //disabled loader
                        this.$notify.error({
                            title: "Fail",
                            message: "Something Went Wrong"
                        });
                    }
                })
                .catch((e) =>{
                    console.log('error', e);
                    this.is_timesheet_loading = false;   //disabled loader
                })
        },

        // confirmation dialog to remove weekly off and leave
        // after confirmation, remove weekly off or leave of emp then assign shift to employee then save his edited details
        openConfirmation(emp_obj, action_type, time_sheet_index){
            if(emp_obj.edit_timesheet_start_hours || emp_obj.edit_timesheet_end_hours || emp_obj.edit_timesheet_break1_start_hours || emp_obj.edit_timesheet_break1_end_hours || emp_obj.edit_timesheet_break2_start_hours || emp_obj.edit_timesheet_break2_end_hours){

                if (action_type == "REMOVE_WEEKLY_OFF") {
                    this.$confirm(
                        "Employee selected  is on weekly off. </br> Do you wish to remove?",
                        "Alert",
                        {
                            confirmButtonText: "OK",
                            cancelButtonText: "Cancel",
                            dangerouslyUseHTMLString: true
                        }
                    )
                        .then(() => {
                            this.removedWeeklyOffAndLeave(emp_obj, action_type, time_sheet_index);
                        })
                        .catch(() => {});
                }else if (action_type == "REMOVE_LEAVE") {
                    this.$confirm(
                        "Employee selected  is on Leave. </br> Do you wish to remove?",
                        "Alert",
                        {
                            confirmButtonText: "OK",
                            cancelButtonText: "Cancel",
                            dangerouslyUseHTMLString: true
                        }
                    )
                        .then(() => {
                            this.removedWeeklyOffAndLeave(emp_obj, action_type, time_sheet_index);
                        })
                        .catch(() => {});
                }

            }else{
                this.$notify.error({
                    title: "Errror",
                    message: 'Please select input first'
                });
            }
        },

        //api to remove weekly off and leave of emp
        // after removing weekly off or leave assign shift to employee
		removedWeeklyOffAndLeave(emp_obj, action_type, time_sheet_index) {
            this.is_timesheet_loading = true;   //enabled loader

			if (action_type == "REMOVE_WEEKLY_OFF") {

                let weekly_off_assigned_emp_list = [];

                //collected all employees who have weekly off except selected employee

                for(let j=0; j<this.time_sheet_list[time_sheet_index].emp_list.length; j++){
                    if (this.time_sheet_list[time_sheet_index].emp_list[j].employee != emp_obj.employee && this.time_sheet_list[time_sheet_index].emp_list[j].weekly_off_id) {

                        let obj = {
                            auto_sheduled: true,
                            date: this.time_sheet_list[time_sheet_index].emp_list[j].shift_date,
                            employee: this.time_sheet_list[time_sheet_index].emp_list[j].employee,
                            id: this.time_sheet_list[time_sheet_index].emp_list[j].weekly_off_id,
                            store: this.time_sheet_list[time_sheet_index].emp_list[j].outlet,
                        }

                        weekly_off_assigned_emp_list.push(obj);
                    }
                }

                // passed date of timeslot as a start and end date from which employee is selected
                let params = {
					data: weekly_off_assigned_emp_list,
					store: emp_obj.outlet,
					start_date: moment(this.time_sheet_list[time_sheet_index].date).format("YYYY-MM-DD"),
					end_date: moment(this.time_sheet_list[time_sheet_index].date).format("YYYY-MM-DD")
				};

                // console.log('params', params);
				LabourPalnningService.saveWeeklyOffNetworkCallBack(params)
                .then(response => {
                    if (response.status == 200) {
                        // after removing weekly off, assign shift to that emp and then update edited deails
                        this.assignShiftToSelectedEmp(emp_obj, time_sheet_index);
                    }else{
                        this.is_timesheet_loading = false;   //disabled loader
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.is_timesheet_loading = false;   //disabled loader
                });

			} if (action_type == "REMOVE_LEAVE") {
                // console.log('REMOVE_LEAVE', emp_obj);
                let obj = {};
				obj.store = emp_obj.outlet;
				obj.employee = emp_obj.employee;
				obj.leave_type = emp_obj.leave_obj.leave_type;
				obj.is_paid = emp_obj.leave_obj.is_paid;
				obj.start_date = moment(emp_obj.leave_obj.date).format("YYYY-MM-DD");
				obj.end_date = moment(emp_obj.leave_obj.date).format("YYYY-MM-DD");
				obj.total_days = 1;
				obj.description = emp_obj.leave_obj.description;

				LabourPalnningService.deleteLeaveOfEmployeeNetworkCallBack(obj)
					.then(response => {
						if (response.status == 200) {
                            // after removing leave, assign shift to that emp and then update edited deails
                            this.assignShiftToSelectedEmp(emp_obj, time_sheet_index);
						}else{
                            this.is_timesheet_loading = false;   //disabled loader
                        }
					})
					.catch(err => {
						console.log(err);
                        this.is_timesheet_loading = false;   //disabled loader
					});
			}
		},

        assignShiftToSelectedEmp(emp_obj, time_sheet_index){
            // split shift duration
            let hours = emp_obj.prefer_shift_duration.slice(0,2);
            let minutes = emp_obj.prefer_shift_duration.slice(3,5);

            // add hours and minutes
            // passed date of timeslot as a start and end date from which employee is selected
            let added_hours = moment(this.time_sheet_list[time_sheet_index].date).add(hours, 'hours').format('YYYY-MM-DD HH:mm:ss');
            let added_minutes = moment(added_hours).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm');

            // calculate start and end time
            let start_time = moment(this.time_sheet_list[time_sheet_index].date).format('YYYY-MM-DD HH:mm') + ':00';
            let end_time = moment(added_minutes).format('YYYY-MM-DD HH:mm:ss');

            // console.log(start_time, end_time)

            let new_shiftparams = {
                id: null,
                store: emp_obj.outlet,
                partner: emp_obj.employee,
                start_time: start_time,
                end_time: end_time,
                auto_sheduled: false,
                for_date: moment(this.time_sheet_list[time_sheet_index].date).format("YYYY-MM-DD"),
                function: emp_obj.function,
                overtime: '00:00:00',
                notes: ""
            };

            LabourPalnningService.saveShiftOfEmployeeNetworkCallBack(new_shiftparams)
                .then(response => {
                	if (response.status == 201) {
                        // after adding shift passed emp obj and status to change status api
                        this.updateTimesheet(emp_obj);   //called api to save edited details
                	} else {
                       this.is_timesheet_loading = false;   //disabled loader
                    }
                })
                .catch((e) =>{
                    console.log('error', e);
                    this.is_timesheet_loading = false;   //disabled loader
                })
        },

        assignShiftToNoShiftAssignedEmp(emp_obj){
            this.is_timesheet_loading = true;   //enabled loader

            // split shift duration
            let hours = emp_obj.prefer_shift_duration.slice(0,2);
            let minutes = emp_obj.prefer_shift_duration.slice(3,5);

            // add hours and minutes
            // passed date of timeslot as a start and end date from which employee is selected
            let added_hours = moment(emp_obj.shit_date).add(hours, 'hours').format('YYYY-MM-DD HH:mm:ss');
            let added_minutes = moment(added_hours).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm');

            // calculate start and end time
            let start_time = moment(emp_obj.shit_date).format('YYYY-MM-DD HH:mm') + ':00';
            let end_time = moment(added_minutes).format('YYYY-MM-DD HH:mm:ss');

            // console.log(start_time, end_time)

            let new_shiftparams = {
                id: null,
                store: emp_obj.outlet,
                partner: emp_obj.employee,
                start_time: start_time,
                end_time: end_time,
                auto_sheduled: false,
                for_date: moment(emp_obj.shit_date).format("YYYY-MM-DD"),
                function: emp_obj.function,
                overtime: '00:00:00',
                notes: ""
            };

            LabourPalnningService.saveShiftOfEmployeeNetworkCallBack(new_shiftparams)
                .then(response => {
                	if (response.status == 201) {
                        // after adding shift passed emp obj and status to change status api
                        this.updateTimesheet(emp_obj);   //called api to save edited details
                	} else {
                       this.is_timesheet_loading = false;   //disabled loader
                    }
                })
                .catch((e) =>{
                    console.log('error', e);
                    this.is_timesheet_loading = false;   //disabled loader
                })
        },

        completeTimesheetDetails(params){
            return LabourPalnningService.completeTimesheetDetailskNetworkCallBack(params)
            .then(response => {
                return response;
            })
            .catch((e) =>{
                console.log('error', e);
            })
        },
    },

    beforeDestroy() {
		EventBus.$off("loadAllApis");

        let obj = {
            scheduled_labour_hours: '',
            scheduled_labour_cost: '',
            actual_labour_hours: '',
            actual_labour_cost: '',
            total_leaves: '',
            total_absents: '',
            total_late: '',
            total_weekly_off: '',
            total_overtime: '',
            total_early_out: '',
        }

        this.$store.commit('commitTimesheetSummary', obj);
	}
}
</script>
<style lang="scss" scoped>
.ManageTimeSheet{
    .timsheet-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        // border: 1px solid #bebebe;

        thead th {
            // height: 25px;
            line-height: 35px;
            height: 35px;
            text-align: left;
            color: #707070;
            background-color: #f2f2f2!important;
            text-transform: uppercase;
            font-size: 12px;
        }

        tbody td, thead th {
            width: 12.12%;
            float: left;
            text-align: center;
        }

        td{
            height: 80px;
            padding: 10px 0;
            font-size: 0.7rem;
        }

        tbody tr{
            border-bottom: 1px solid #eee;
        }

        .title{
            font-weight: bold;
        }
        .sub-title{
            color: #999;
        }
    }
    .highliter{
        background-color: #f5f6fa;
        padding: 4px 10px;
        width: fit-content;
        margin: 0 auto;
        cursor: pointer;
    }
    .task-highliter{
        color: #fff;
        border-radius: 4px;
        padding: 3px 10px;
        font-size: 10px;
        font-weight: 600;
        width: fit-content;
        margin: 0 auto;
    }
    .status-highliter{
        color: #fff;
        border-radius: 4px;
        padding: 3px 10px;
        font-size: 10px;
        line-height: 1.5;
        font-weight: 600;
        width: fit-content;
        margin: 0 auto;
        cursor: pointer;
    }

    thead, tbody, tr, td, th {
        display: block;
    }
    //   tbody tr{
    //     // border-bottom: 1px solid #bebebe;
    //   }
    tr:after {
        content: ' ';
        display: block;
        visibility: hidden;
        clear: both;
    }

    label{
        font-size: 0.6rem;
        // font-weight: 500;
        display: block;
        margin-bottom: 3px;
        color: #000;
        // text-align: left;
    }
    .action-btn {
        background-color: #E29D5A;
        border-color: #E29D5A;
        color: #fff;
    }
    .ellipsis{
        white-space: nowrap;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 auto;
    }

}
.ns-img-avatar{
    border-radius: 99px;
    width: 50px;
}
.ns-avatar-sec{
    display: flex;
    align-items: center;
}
.ns-approve-btn{
    background: #41BE62;
    color: #fff;
    padding: 12px 35px;
    border-radius: 8px;
    font-weight: 600;
}
.ns-cancel-btn{
    border: none;
    padding: 12px 35px;
    border-radius: 8px;
    font-weight: 600;
}
</style>
<style lang="scss">
.scheduled-shift-table {
    table-layout: fixed;
    width: 100%;
    thead {
        // display: table; /* to take the same width as tr */
        // width: calc(100% - 14px); /* - 17px because of the scrollbar width */
        border-bottom: 1px solid #ddd;
    }
    tbody{
        // display: block;
        // max-height: 200px;
        // overflow-y: auto;
    }
    // tr {
    //     display: table; /* display purpose; th's border */
    //     width: 100%;
    //     box-sizing: border-box; /* because of the border (Chrome needs this line, but not FF) */
    // }
    th, td{
        text-align: center;
        width: 50%;
        font-size: 11px;
        padding: 5px;
        text-align: center;
    }
    th:first-child, td:first-child{
        text-align: left;
    }
}
</style>
<style>

.ns-dialog .el-dialog__header {
    background: #fdfdfd;
    color: #1c1b1b;
    padding: 25px 20px;
    border-radius: 8px;
}

.ns-dialog.el-dialog {
    border-radius: 8px;
}

.ns-dialog .el-dialog__title {
    text-transform: capitalize;
    color: #1c1b1b;
    font-weight: 700;
}

.ns-dialog .el-dialog__footer {
    /* position: fixed; */
    bottom: 0;
    width: 100%;
    padding: 15px 35px;
    background: #fff;
    border-radius: 8px;
}
.ns-dialog .el-dialog__body {
    padding: 5px 20px 30px 20px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.ns-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    font-weight: 600;
    font-size: 25px;
}
</style>
